<template>
    <div id="app" class="flex flex-col items-center w-full min-h-screen bg-gray-200">
        <div class="flex flex-wrap w-full sm:w-2/3">
            <div class="loader" v-show="loading">Loading...</div>
        </div>
        <div v-if="!loading" class="relative flex flex-wrap w-full">
            <div class="absolute z-10 flex items-center justify-center w-full p-2">
                <input
                    v-model="search"
                    class="w-full px-2 py-1 sm:w-1/2"
                    placeholder="Find a team..."
                />
            </div>
            <Map
                :paths="this.rawCrewPathData"
                :mapView="mapView"
                :currentcenter="this.center"
                :locations="
                    this.filteredResults
                        .map(event => {
                            return [
                                event.id,
                                event.longitude != '' ? Number(event.longitude) : null,
                                event.latitude != '' ? Number(event.latitude) : null,
                                event.org_group_colour != '' ? event.team_colour : '#3e3d3f',
                                event.dot_border_colour != '' ? event.team_border_colour : '#000',
                            ]
                        })
                        .filter(item => item[1] != null || item[2] != null)
                "
                :events="this.events.filter(event => event.latitude != '' && event.longitude != '')"
                class="w-full"
            ></Map>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Map from './components/Map'
export default {
    name: 'App',
    components: {
        Map,
    },
    data() {
        return {
            mapView: true,
            zoom: 12,
            center: [-1.5603840348834268, 54.78128107509557],
            rotation: 0,
            selected: 'NYC',
            search: '',
            url:
                'https://script.google.com/macros/s/AKfycbyii0Spv_S6OFI9fqNSLD-hJtn8uRsTjBezxrspaE1KHXaA3jIhli0H0b6DtFr_3MD8/exec',
            events: [],
            loading: true,
            rawCrewPathData: [],
            crewPathsDataUrl:
                'https://script.googleusercontent.com/macros/echo?user_content_key=l1tjrNWGsijdCHQfoS9sbfexPCFWrgLX96fCfaikEm2phXFOIUy6q1-eacmN_K8hjhHEm_9Jn512KPdUIPTrj6JAIn21BWhqm5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnJZOyA8tTWy6XHedgXkFb-sVvTHnkwutB7NQWpotAFsmW4h47FTiTRS50ypLpr0fuk9aVGtuCRy3tydZzOyr3uTQqzqdn85bng&lib=MYUAdkuj1SB-2BggcB7iaTDnoK3vkZz2C',
        }
    },
    // https://docs.google.com/spreadsheets/d/1LVIs0zE136gvKz8PgKt18pokGUqQevFS2ffq8RJXln8/edit#gid=0

    computed: {
        publishedEvents: function() {
            return this.events
        },
        filteredResults: function() {
            let filtered = this.events
            if (this.search != '') {
                let searchTerm = this.search.toLowerCase()
                filtered = filtered.filter(
                    item =>
                        item.team_name.toLowerCase().includes(searchTerm) ||
                        item.organisation.toLowerCase().includes(searchTerm)
                )
            }
            return filtered
        },
    },
    methods: {
        getData: function() {
            axios.get(this.url).then(response => {
                this.events = response.data[0].data
            })
            axios.get(this.crewPathsDataUrl).then(response => {
                this.rawCrewPathData = response.data[0].data
                this.loading = false
            })
        },
        updateEvents: function() {
            this.loading = true
            axios.get(this.url[this.selected].url).then(response => {
                this.events = response.data.feed.entry
                this.loading = false
            })
        },
        displayDate: function(date) {
            let d = new Date(date.replace(/-/g, '/'))
            let day = d.getDate()
            let month = d.getMonth()
            if (isNaN(day) || isNaN(month)) {
                return '-'
            }
            return month + 1 + '/' + day
        },
        futureDate: function(date) {
            let event = new Date(date.replace(/-/g, '/'))
            let eventDay = event.getDate()
            if (isNaN(eventDay)) {
                return false
            }
            let now = new Date()
            let nowDay = now.getDate()
            console.log({ nowDay })
            return eventDay >= nowDay
        },
        toggleMap: function() {
            this.mapView = !this.mapView
        },
        displayTime: function(date) {
            let d = new Date(date.replace(/-/g, '/'))
            let hours = d.getHours()
            if (hours > 12) {
                hours = hours - 12
            }
            let minutes = d.getMinutes()
            if (minutes < 10) {
                minutes = '0' + minutes
            }
            if (isNaN(hours)) {
                hours = '00'
            }
            if (isNaN(minutes)) {
                minutes = '00'
            }
            return hours + ':' + minutes
        },
    },
    created() {
        this.getData()
    },
}
</script>

<style src="./assets/css/tailwind.css"></style>
<style type="text/css">
.loader,
.loader:before,
.loader:after {
    background: #000;
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
}
.loader {
    color: #000;
    text-indent: -9999em;
    margin: 88px auto;
    position: relative;
    font-size: 11px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}
.loader:before,
.loader:after {
    position: absolute;
    top: 0;
    content: '';
}
.loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}
.loader:after {
    left: 1.5em;
}
@-webkit-keyframes load1 {
    0%,
    80%,
    100% {
        box-shadow: 0 0;
        height: 4em;
    }
    40% {
        box-shadow: 0 -2em;
        height: 5em;
    }
}
@keyframes load1 {
    0%,
    80%,
    100% {
        box-shadow: 0 0;
        height: 4em;
    }
    40% {
        box-shadow: 0 -2em;
        height: 5em;
    }
}
</style>
